<template>
    <div id="main">
        <div class="page">
            <div class="novo-formulario">
                <h1 class="title">{{ $t('resposta-formulario') }}: {{ ' ' + title }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a>
                                {{ isPromotor ? $t('promotor') : $t('vendas') }}
                            </a>
                        </li>
                        <li>
                            <a>
                                {{ isPromotor ? $t('relatorios') : $t('formulario') }}
                            </a>
                        </li>
                        <li>
                            <router-link
                                :to="{
                                    name: isPromotor
                                        ? 'formulario-respondido-consulta'
                                        : 'ven-formulario-respondido-consulta',
                                }"
                                >{{ $t('formulario-respondido-consulta') }}
                            </router-link>
                        </li>
                        <li>
                            <a href="#" aria-current="page">{{ title }}</a>
                        </li>
                    </ul>
                </nav>
                <div class="center">
                    <div v-for="(d, i) in answers" :key="i" class="fr-chart" ref="chartItem">
                        <DonutChart
                            :title="d.titulo"
                            :datacontent="d"
                            v-if="d && d.tipo == 'donut'"
                        />
                        <BarChart
                            :title="d.titulo"
                            :datacontent="d"
                            :direction="d.direction"
                            v-if="d && d.tipo == 'bar'"
                        />
                        <PieChart :title="d.titulo" :datacontent="d" v-if="d && d.tipo == 'pie'" />
                        <LongTextChart
                            :title="d.titulo"
                            :datacontent="d.items"
                            v-if="d && d.tipo == 'longtext'"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormularioService from '@/services/FormularioService';
import DonutChart from '@/components/shared/chart/DonutChart';
import PieChart from '@/components/shared/chart/PieChart';
import LongTextChart from '@/components/shared/chart/LongTextChart';
import BarChart from '@/components/shared/chart/BarChart';

export default {
    components: {
        DonutChart,
        PieChart,
        BarChart,
        LongTextChart,
    },
    data() {
        return {
            title: '',
            answers: [],
            permissao: {},
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
        };
    },
    created() {
        if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'relatorios',
                'formulario-respondido-consulta'
            );
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'formulario',
                'ven-formulario-respondido-consulta'
            );
        }

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });

        this.service = new FormularioService(this.$http, this.$router);

        if (this.$route.params.id) {
            this.editable = false;
            this.carregarDados(this.$route.params.id);
        }
        this.$on('update-grupoperguntas', this.updateGrupoperguntas);
    },
    methods: {
        carregarDados(id) {
            this.service.findAnswersFromForm(id).then((body) => {
                if (body.content) {
                    this.answers = body.content.charts;
                }
            });

            this.service.find(id).then((body) => {
                if (body.content) {
                    this.title = body.content.descricao;
                }
            });
        },
    },
    computed: {
        camposorder: {
            get() {
                return this.$store.state.camposorder;
            },
            set(value) {
                this.$store.commit('updateList', value);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    padding: 20px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 80px;

    .novo-formulario {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;

        h1.title {
            margin: 0;
        }

        .center {
            width: 100%;
            left: 0;
            transform: translateX(0);
            margin: 0;
            box-sizing: border-box;
            position: initial;
            padding-top: 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;

            .fr-chart {
                position: relative;
                margin-bottom: 10px;
                width: 49%;
            }
        }
    }
}
</style>
